<template>
  <div id="app">
    <Header v-if="
      (['/landingpage', '/iraq', '/ksa'].indexOf($route.path) < 0 &&
        [
          '/mob-about-us/' +
          $route.params.lang +
          '/' +
          $route.params.cinemaType,
        ].indexOf($route.path) < 0 &&
        [
          '/mob-tnc/' + $route.params.lang + '/' + $route.params.cinemaType,
        ].indexOf($route.path) < 0 &&
        [
          '/mob-ksa-tnc/' +
          $route.params.lang +
          '/' +
          $route.params.cinemaType,
        ].indexOf($route.path) < 0 &&
        [
          '/theatre-rules-mob/' +
          $route.params.lang +
          '/' +
          $route.params.cinemaType,
        ].indexOf($route.path) < 0 &&
        siteURL != '__empirecinemas.com__' &&
        siteURL != 'localhost:8082') ||
      (siteURL == 'localhost:8082' && languageVal)
    " />

    <main class="site-main">
      <router-view></router-view>
    </main>
    <!-- {{$route}} -->
    <Footer v-if="$route.path != '/seats'" />
  </div>
</template>

<script>
import Vue from "vue";
import VueRouter from "vue-router";
import { Slide } from "vue-burger-menu"; // import the CSS transitions you wish to use, in this case we are using `Slide`
import Header from "@/components/partials/header.vue";
import Footer from "@/components/partials/footer.vue";
import VueYouTubeEmbed from "vue-youtube-embed";
import { LanguageService } from "@/services/storage.service";
// import "./assets/css/style.css";
// import "./assets/css/preimere-css.css";

// let preimereToken = window.localStorage.getItem("PREIMERE");
// if (
//   preimereToken == "null" ||
//   preimereToken == null ||
//   preimereToken == "false" ||
//   preimereToken == false
// ) {
//   import("./assets/css/style.css").then(something => {
//     import("./assets/css/responsive.css");
//   });
// } else {
//   import("./assets/css/preimere-css.css").then(something => {
//     import("./assets/css/responsive.css");
//   });
// }

export default {
  components: {
    Header,
    Footer,
    Slide,
  },
  name: "app",
  created() {
    let elem = document.getElementById("loader");
    elem.remove();
  },
  watch: {
    $route(to, from) {
      // console.log(to.path)
      Vue.analytics.fbq.event("PageView", {
        content_name: to.path,
      });
      this.$ga.page({
        page: to.path,
        location: window.location.href,
      });
      // this.$ga.event({
      //   eventCategory: 'category',
      //   eventAction: 'action',
      //   eventLabel: 'label',
      //   eventValue: 123
      // })
    },
  },
  computed: {
    siteURL() {
      return window.location.host;
    },
    languageVal() {
      return localStorage.getItem("language");
    },
  },
  beforeMount() {
    /*
    console.log(localStorage.getItem("country"), "CountryNew");
    if (
      localStorage.getItem("country") &&
      !localStorage.getItem("brij_country")
    ) {
      let country_parse = JSON.parse(localStorage.getItem("country"));
      console.log(country_parse, "country_parse");
      if (String(country_parse.CountryID) == "230") {
        localStorage.clear();
        window.location.reload();
      }
    }
    */
    console.log = () => { }
    this.showLoading();
    this.$store.dispatch("fetchBrijBanners");
    // this.$store.dispatch("fetchUpcoming");
    this.$store.dispatch("fetchExperienceFormat");

    Promise.all(
      [
        this.$store.dispatch("fetchGlobalOptions"),
        this.$store.dispatch("fetchBrijCinemasAndCountries"),
        this.$store.dispatch("fetchNowShowing"),
      ].map((p) =>
        p
          .then((value) => ({ status: "fulfilled", value }))
          .catch((reason) => {
            console.log({ status: "rejected", reason });
            return { status: "rejected", reason };
          })
      )
    ).finally(() => {
      this.hideLoading();
    });

    let time = 1200;
    let outdated = [
      "1",
      "0.1.1",
      "0.1.2",
      "0.1.3",
      "0.1.4",
      "0.1.5",
      "0.1.6",
      "0.1.7",
      "0.1.8",
      "0.1.9",
      "2",
      "2.1.1",
      "2.1.2",
      "2.1.3",
    ];
    let current = "2.1.4";
    let version = localStorage.getItem("version");
    if (version) {
      console.log({ version }, outdated.includes(version));
      // if (outdated.includes(version)) {
      //   setTimeout(() => {
      //     localStorage.clear()
      //     localStorage.setItem('version', current)
      //     window.location.reload()
      //   }, time)
      // }
    } else {
      localStorage.setItem("version", current);
    }

    let device_id = localStorage.getItem("x-device-id");
    if (device_id) {
      console.log({ device_id });
    } else {
      localStorage.setItem(
        "x-device-id",
        Math.random()
          .toString(36)
          .slice(2) +
        Math.random()
          .toString(36)
          .slice(2)
      );
    }
  },
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/App.vue